import axios from "axios";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList } from "../../../../components/links/Links";
import UserAvatar from "../../../../components/user/UserAvatar";
import { authHeader } from "../../../../header";
import { getUserInititals } from "../../../../utils/Utils";

const User = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [admin, setAdmin] = useState();
  const getAdmin = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/users/${userInfo.id}`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setAdmin(resultData);
        localStorage.setItem("referralCode", JSON.stringify(resultData.myReferralCode));
      }
    } catch (error) {}
  };

  const logout = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/logout`,
        {},
        {
          headers: authHeader(),
        }
      );
      toast.success("Logout successfully.", {
        position: toast.POSITION.TOP_CENTER,
      });
      if (response) {
        localStorage.clear();
        window.location.href = "/auth-login";
      }
    } catch (error) {}
  };

  useEffect(() => {
    getAdmin();
  }, []);

  const handleSignout = () => {
    logout();
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
          <div className="user-info d-none d-md-block">
            <div className="user-status">{admin?.assignedRole?.roleName}</div>
            <div className="user-name dropdown-indicator">{admin?.contactName}</div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <span>{getUserInititals(admin?.contactName ?? "")}</span>
            </div>
            <div className="user-info">
              <span className="lead-text">{admin?.contactName}</span>
              <span className="sub-text">{admin?.email}</span>
            </div>
          </div>
        </div>
        {/* <div className="dropdown-inner">
          <LinkList>
            <LinkItem link="/user-profile-regular" icon="user-alt" onClick={toggle}>
              View Profile
            </LinkItem>
            <LinkItem link="/user-profile-setting" icon="setting-alt" onClick={toggle}>
              Account Setting
            </LinkItem>
            <LinkItem link="/user-profile-activity" icon="activity-alt" onClick={toggle}>
              Login Activity
            </LinkItem>
          </LinkList>
        </div> */}
        <div className="dropdown-inner">
          <LinkList>
            <div style={{ cursor: "pointer" }} onClick={handleSignout}>
              <Icon name="signout" />
              <span>Sign Out</span>
            </div>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;
